module.exports = __webpack_public_path__ + "img/background-white.0a893a40.png";